<template>
  <Button
    type="button"
    shape="circle"
    :color="props.color"
    :size="props.size"
    variant="fill"
    class="shrink-0"
    :disabled="disabled"
    :aria-label="t('rt.restore.title')"
    @click="isConfirmOpen = true"
  >
    <Icon icon="Function-Wireframe-CCW" />
  </Button>

  <Dialog
    v-model:open="isConfirmOpen"
    :title="t('rt.restore.title')"
    content-class="w-90"
    :close-on-overlay-click="false"
  >
    <p class="text-s-medium text-text-glass-default">
      {{ t('rt.restore.content') }}
    </p>

    <template #footer>
      <div class="flex w-full justify-end gap-2">
        <Button type="button" color="text-b-w" @click="isConfirmOpen = false">
          {{ t('common.cancel') }}
        </Button>
        <Button type="button" color="black" @click="confirmRestore">
          {{ t('common.confirm') }}
        </Button>
      </div>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
  import { ref } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { Button, Dialog, Icon } from '@rapoo/element'
  import { ButtonVariants } from '@rapoo/element/components/ui/button'

  const props = withDefaults(
    defineProps<{
      disabled?: boolean
      size?: ButtonVariants['size']
      color?: ButtonVariants['color']
    }>(),
    { size: 'icon-sm', color: 'normal' },
  )

  const emit = defineEmits<{
    confirm: []
  }>()

  const { t } = useI18n()
  const isConfirmOpen = ref(false)

  function confirmRestore() {
    isConfirmOpen.value = false
    emit('confirm')
  }
</script>
